import { formatInTimeZone } from 'date-fns-tz';

import { Locale } from '../application';

/**The date utilities in this file force the dates to adhere to Amsterdam time, regardless of where the user is
 * visiting from.  */

const timeZone = 'Europe/Amsterdam';

export const getAmsterdamHours = (date: Date) => +formatInTimeZone(date, timeZone, 'HH');

export const isTodayAmsterdam = (date: Date) => {
  return (
    formatInTimeZone(date, timeZone, 'dd') === formatInTimeZone(new Date(), timeZone, 'dd') &&
    formatInTimeZone(date, timeZone, 'MM') === formatInTimeZone(new Date(), timeZone, 'MM') &&
    formatInTimeZone(date, timeZone, 'yyyy') === formatInTimeZone(new Date(), timeZone, 'yyyy')
  );
};

export const formatAmsterdamTime = (date: Date, showMinutes = true) =>
  formatInTimeZone(date, timeZone, showMinutes ? 'HH:mm' : 'HH');

export const formatShortISOAmsterdam = (date: Date) => formatInTimeZone(date, timeZone, 'yyyy-MM-dd');

export const formatAmsterdamDate = (date: Date, locale: Locale) =>
  date.toLocaleString(locale, {
    dateStyle: 'long',
    timeZone,
  });
